export * from './propertiesFragments';